<template>  
    <section>
        <!-- 支付弹框 -->
		<pay-modal :detailList="detailList"  :payName="payName"   v-if="isShowModal" :showClose="true"
            @close-modal="onCloseModalClick"  @selectPayType="selectPayType" @payClick='payClick' :addClickPay="addClickPay" :clickPay="clickPay">
        </pay-modal>
		
		<!-- 钱包余额不足弹框 -->
		<confirm-modal v-if="noEnough" :isEnough="true" :firmTitle="firmTitle" :firmLeft="firmLeft" :firmRight="firmRight"
            @leftClick="onCloseModalClick" @rightClick="goToCharge">
        </confirm-modal>
		
		<!-- 设置处理人员 -->
		<common-modal :showClose="true" v-if="isDispatch"  @close-modal="onCloseModalClick">
		    <div class="modal">
		        <div class="title">设置处理人员信息</div>
				<div class="sale-wrap">
					<p class="name-title">业务员</p>
					<select v-model="saleSelect" @blur="backHeight">
						<option v-for="(item,index) in salesMan" :key="index" :value="item.uuid">{{item.user_name}}</option>
					</select>
					<p class="name-title">佣金比例</p>
					<div class="commission-wrap">
						<input placeholder="请输入佣金比例" type="tel" v-model="commissionCash" @blur="backHeight"/>
						<span>%</span>
					</div>
				</div>
				<div class="submit-sale" @click="submitPlace">确认下单</div>
		    </div>
		</common-modal>
		
		<qr-code-url v-if="qrcodeUrl" :qrcodeUrl="qrcodeUrl" tips="支付" :chargeMoney="detailList.order_total_price" @deletePay="onCloseModalClick"></qr-code-url>

        <ul class="order-content">
            <li class="order-detail">
                <div class="order-wrap">
					<img :src="imgUrl+detailList.server_info.server_icon" alt="" class="pt-img"/>
                    <span class="service-left">{{detailList.server_info.server_name}}</span>
                </div>
                
                <div class="order-wrap un-boder">
                    <span class="order-left">基础服务价格</span>
                    <span class="order-left">¥{{detailList.server_info.server_price}}</span>
                </div>
            </li>
            
            <li class="order-detail">
                <div class="link-wrap">
            		<img src="../../assets/images/home/ic_home_line_1.png" alt="" class="pt-img"/>
                    <span class="link" v-text='detailList.server_type==1?"商品链接":"店铺链接"'></span>
                </div>
                <div class="show-link">{{detailList.question_url}}</div>
            </li>
            
            <li class="order-detail p-b">
                <div class="link-wrap">
                	<img src="../../assets/images/home/ic_home_line_2.png" alt="" class="pt-img"/>
                    <span class="link">消费者信息</span>
                </div>
                
                <div class="customer-info">
                    <span class="info-style">消费者姓名</span>
                    <span class="info-style">{{detailList.consumer_name}}</span>
                </div>
                
                <div class="customer-info" v-if="detailList.server_type==1">
                    <span class="info-style">消费者旺旺</span>
                    <span class="info-style">{{detailList.consumer_wangwang}}</span>
                </div>
                
                <div class="customer-info">
                    <span class="info-style">手机号码</span>
                    <span class="info-style">{{detailList.consumer_mobile}}</span>
                </div>        
            </li>
            
            <li class="order-detail p-b">
                <div class="link-wrap">
                	<img src="../../assets/images/home/ic_home_line_3.png" alt="" class="pt-img"/>
                    <span class="link">商家信息</span>
                </div>
                
                <div class="customer-info" v-if="detailList.server_type==1">
                    <span class="info-style">商家旺旺</span>
                    <span class="info-style">{{detailList.merchant_wangwang}}</span>
                </div>  
                 
                <div class="customer-info">
                    <span class="info-style">手机号码</span>
                    <span class="info-style">{{detailList.merchant_mobile}}</span>
                </div>
            </li>
            
            <li class="order-detail p-b" v-if="detailList.after_sale_name">
                <div class="link-wrap">
                	<img src="../../assets/images/home/ic_home_line_4.png" alt="" class="pt-img"/>
                    <span class="link">店铺售后授权</span>
                </div>
                
                <div class="customer-info f-s">{{detailList.after_sale_name}}</div>
                
                <div class="customer-info" v-if="detailList.after_sale_type==2">
                    <span class="info-style">最大允许补偿金额</span>
                    <span class="info-style">¥{{detailList.compensation_price}}</span>
                </div>
				
				<div class="show-link" v-if="detailList.after_sale_type==4">{{detailList.other_sale_massage}}</div>
            </li>
            
            <li class="order-detail">
                <div class="link-wrap">
                	<img src="../../assets/images/home/ic_home_line_5.png" alt="" class="pt-img"/>
                    <span class="link">情况概述</span>
                </div>
                <span class="un-connection">{{detailList.order_details_tag}}</span>
                <p class="describe">{{detailList.order_details}}</p>
                <div class="img-list">
                    <img v-for="(item,index) in order_image" :key="index" :src="item" alt="" @click="handleImgsClick(order_image,index)" class="img-size" />
                </div>
            </li>
            
            <li class="order-detail" v-if="!isAdmin">
                <div class="link-wrap" @click="isAgree">
                	<span class="agree-img" :class='imgFlag? "agree" : "un-agree"'></span>
                    <span class="link">同意以下服务协议</span>
                </div>
                
                <div class="agree-text">
                   <p>1、处理期间，请拉黑或不与买家联系咯，不对对评价解释或回复哈，谢谢您（已经解释了不影响处理）；</p>
                   <p>2、我们处理周期是五天哈，期限内请不要无故撤单咯，违约需要扣除订单金额50%违约金喔 ；</p>
                   <p>3、五天处理期限内，请不要自行处理或交他人处理哈，五天期限内解决的订单，都得收取费用喔 。</p> 
                </div>
            </li>
        </ul>
        
        <submit-pay @submitClick="confirmClick" :money="detailList.order_total_price" :step="step"></submit-pay>
    </section>
</template>

<script>
	import CommonModal from '@/components/CommonModal'
    import CommonHeader from '@/components/CommonHeader'
    import PayModal from '@/components/PayModal'
    import ConfirmModal from '@/components/ConfirmModal'
	import QrCodeUrl from '@/components/QrCodeUrl'
	import {getOrderDetail,getOrderPay,getSalesman,placeOrderAdmin,getCommission} from '@/api/order'
	import utils from '@/assets/jslibs/utils'
    import submitPay from '@/components/submitPay'
    export default {
        name: 'confirm-order',
        data(){
            return{
				imgUrl:this.$store.state.imgUrl || sessionStorage.getItem("imgUrl"),
				isDispatch:false,
				commissionCash:"",
				saleSelect:"",		//选中的业务员
				order_uuid:this.$route.query.order_uuid,
				isAdmin:this.$route.query.isAdmin,
                firmTitle:"钱包余额不足 该充值啦",
                firmLeft:"返回",
                firmRight:"充值",
				step:"确认下单",
				noEnough:false,  //余额不足弹框
                imgFlag:false,
				isShowModal:false,
				payTypeModal:false,
				salesMan:[],          //所有业务员
				detailList:{
					server_info:{}
				},
				qrcodeUrl : '',
				timer:null,
				isMobile : utils.isMobile(),
                payName:"微信支付" ,      //选择支付的名称
                payStyle:1,                //选择支付的方式
                clickPay:true,			//判断是否可以点击支付，防止重复点击
                addClickPay:true,
				order_image:[]			//用于页面展示，已经拼上域名，传给后台的不加域名
            }
        },
        components: {
			CommonModal,
            CommonHeader,
            PayModal,
            ConfirmModal,
            submitPay,
			QrCodeUrl
        },
		
		beforeCreate(){
			if(this.$route.query.isAdmin && this.$route.query.isAdmin=="admin"){
				sessionStorage.removeItem("roleType");
			}else{
				sessionStorage.setItem("roleType","customer")
			}
		},
       
        created() {
            window.scrollTo(0,0);
			if(this.isAdmin && this.isAdmin=="admin"){//管理员下单从缓存取用户填写信息
				this.detailList =  JSON.parse(sessionStorage.getItem("params"));
                this.detailList.order_total_price = this.detailList.server_info.server_price     //缓存里面只有服务价格，无订单价格
				this.order_image = this.detailList.order_images.map((item,index)=>{
					return item
				})
				
				if(this.order_image && this.order_image.length){
				    this.order_image.forEach((item,index)=>{
				       this.order_image[index] = this.imgUrl + this.order_image[index];
				    })
				}
				this.getSalesman();
                this.getCommission()
			}else{
				this.getOrderDetail()
			}
        },
        
        mounted(){
           document.title = "订单详情";
			window.addEventListener('touchmove', (event)=>{ 
				if(this.isShowModal || this.payTypeModal || this.noEnough || this.isDispatch){
					event.preventDefault(); 
				}
			});
			
			window.addEventListener('pageshow',()=>{
			    if(sessionStorage.getItem("havePay") && sessionStorage.getItem("payId")) {
			        this.order_uuid = sessionStorage.getItem("payId");      //取成功支付之后的订单号
			        this.getPayStatus();
                    sessionStorage.removeItem("havePay");
                    sessionStorage.removeItem("payId");
			    }
			})
        },
        
        methods: {
			//获取订单详情
			async getOrderDetail(){
				const { data, status } = await getOrderDetail(this.order_uuid);
				if (status == 200){ 
					this.detailList = data;
					this.detailList.after_sale_name = utils.typeToName(this.detailList.after_sale_type);
					this.order_image = this.detailList.order_images.map((item,index)=>{
						return item
					})
					if(this.order_image && this.order_image.length){
					    this.order_image.forEach((item,index)=>{
					       this.order_image[index] = this.imgUrl + this.order_image[index];
					    })
					}
				}
			},
			
			//获取所有业务员
			async getSalesman(){
				let obj={page_index:"1",page_size:"999"}
				const { data, status } = await getSalesman(obj);
				if (status !== 200) return  
				this.salesMan = data.data
				this.saleSelect = this.salesMan[0].uuid;     //下拉框默认选中第一个
			},
            
            //获取默认佣金
            async getCommission(){
            	const { data, status } = await getCommission();
            	if (status !== 200) return  
            	this.commissionCash = Number(data.commission_rate)*100;
            },
            
            navigateTo(path){
                this.$router.push(path)
            },
            
            //勾选协议
            isAgree(){
               this.imgFlag =!this.imgFlag
            },
			
			// 确认下单
			confirmClick(){
				if(this.isAdmin && this.isAdmin=="admin"){
					this.isDispatch =true
				}else{
					if(!this.imgFlag ){
						window.toast('请勾选平台协议', 'txt');
						window.scrollTo(0,document.body.scrollHeight)
						return;
					}
					this.isShowModal = true
				}
			},
			
			// 确认支付
			async payClick(){
                if(!this.clickPay) {
                	window.toast("请勿重复点击","txt");
                	return;
                }
                this.clickPay = false;
                setTimeout(()=>{
                    this.clickPay = true;
                },3000)
				let obj ={type:this.payStyle,order_uuid:this.detailList.uuid};
				if(this.isMobile==1){
					obj.order_tag = 1
				}else if(this.isMobile==2){
					obj.order_tag = 2
				}else if(this.isMobile==3){
					obj.order_tag = 3
				}
                
				const { data, status } = await getOrderPay(obj);
                this.payTypeModal = false;
                this.isShowModal = false;
				if(status==200){
					if(this.payStyle=="2"){//钱包支付
						this.$router.push({path:"./pay-success",query: {order_uuid:data.order_uuid,flag:"pay",role:"user"}});
					}
					else{//微信支付
						if(obj.order_tag == 2){//扫码支付
							this.isShowModal = false;
							this.order_tag = "2";
							this.qrcodeUrl = data.code_url;							
						} else if(obj.order_tag == 1){
							this.order_tag = "1";
                            sessionStorage.setItem("havePay","havePay");
                            sessionStorage.setItem("payId",data.order_uuid);
							var UserAgent = navigator.userAgent.toLowerCase();
							if(/safari/.test(UserAgent) && !/chrome/.test(UserAgent)){
								var backUrl = "https://server-order.yongxintao.com/#/pay-success?order_uuid="+data.order_uuid+"&flag=pay"+"&role=user";
								sessionStorage.setItem("backUrl",backUrl);
							    location.href = data.mweb_url;
							}else{
							    location.href = data.mweb_url;
							}
						}else if(obj.order_tag == 3){//微信公众号支付
                            let timeStamp = String(data.timeStamp);
                            this.order_tag = "3"
                            this.pay("wxf3c9d00e530fedd8",timeStamp,data.nonceStr,data.package,data.signType,data.paySign);
                        }
					}
					this.order_uuid = data.order_uuid;
					this.getPayStatus()

				}else{
					if(data.error.message == "余额不足" && this.payStyle=="2"){
						this.noEnough = true;
					}
				}
			},
            
            // 调微信支付
            pay(appId,timeStamp,nonceStr,packages,signType,paySign){  
            	let self = this;
                if (typeof WeixinJSBridge == "undefined"){  
                   if( document.addEventListener ){  
                       document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);  
                   }else if (document.attachEvent){  
                       document.attachEvent('WeixinJSBridgeReady', onBridgeReady);   
                       document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);  
                   }  
                }else{  
                   self.onBridgeReady(appId,timeStamp,nonceStr,packages,signType,paySign);  
                }   
            },  
            
            //唤醒微信支付
            onBridgeReady(appId,timeStamp,nonceStr,packages,signType,paySign){
                let self = this;
            	WeixinJSBridge.invoke(
            		'getBrandWCPayRequest',
            		{
            			"appId":"wxf3c9d00e530fedd8",     //公众号名称，由商户传入     
            			"timeStamp":timeStamp,         //时间戳，自1970年以来的秒数     
            			"nonceStr":nonceStr, //随机串     
            			"package":packages,     
            			"signType":signType,         //微信签名方式：     
            			"paySign":paySign //微信签名 
            		},
            		
            		function(res){
            			if(res.err_msg == "get_brand_wcpay_request:ok"){// 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
            				self.$router.push({path:"./pay-success",query: {order_uuid:self.order_uuid,flag:"pay",role:"user"}});
            			}else if (res.err_msg === 'get_brand_wcpay_request:cancel') {
                            window.toast("支付失败","txt");
            			}else if (res.err_msg === 'get_brand_wcpay_request:fail') {
                            window.toast("支付失败","txt");
            			}
            		}
            	)
            },
			
			// 轮询支付状态
			async getPayStatus(){
				clearTimeout(this.timer);
				const { data, status } = await getOrderDetail(this.order_uuid);
				if( status == 200 && data.is_pay == 2){
					clearTimeout(this.timer);
					this.qrcodeUrl = false;
					this.payTypeModal = false;
					this.isShowModal = false;
					this.$router.push({path:"./pay-success",query: {order_uuid:this.order_uuid,flag:"pay",role:"user"}});
				}else{
					clearTimeout(this.timer);
					this.timer = setTimeout(()=>{
						this.getPayStatus()
					},2000)
				}
			},
			
			// 确认线下下单
			async submitPlace(){
				if(!(/^[1-9]\d*(,\d{3})*(\.\d{2})?$/).test(this.commissionCash)){
				    window.toast("佣金比例有误","txt");
				    return
				}
				if(this.commissionCash>100 || this.commissionCash<1){
					window.toast("佣金比例应在1-100之间","txt");
					return
				}
				
				var commission_money = this.commissionCash/100;
				var commission_rate = Number(commission_money.toFixed(2));
				
				let obj ={
					server_uuid:  		this.detailList.server_uuid,                 //服务id
					server_type:  		this.detailList.server_type,    //服务类型(1,2)
					question_url: 		this.detailList.question_url,  				//链接
					consumer_name:		this.detailList.consumer_name,
					consumer_wangwang:	this.detailList.consumer_wangwang,
					consumer_mobile:	this.detailList.consumer_mobile,
					merchant_wangwang:	this.detailList.merchant_wangwang,
					merchant_mobile:	this.detailList.merchant_mobile,
					after_sale_type:	this.detailList.after_sale_type,			//售后类型 (1.2,3,4)
					compensation_price:	this.detailList.compensation_price,		//补偿金额
					other_sale_massage: this.detailList.other_sale_massage,       //其他情况
					order_images:		this.detailList.order_images,
					order_details:		this.detailList.order_details,            //订单实际情况
					order_details_tag:	this.detailList.order_details_tag,		//订单大概情况
					salesman_uuid:		this.saleSelect,
					commission_rate:   	commission_rate

				}
				const { data, status } = await placeOrderAdmin(obj);
				if (status !== 200) return 
				this.$router.push({path:"./pay-success",query: {order_uuid:data.order_uuid,flag:"admin"}})
			},

			// 去充值
			goToCharge(){
				this.noEnough = false;
				this.$router.push({path:"./recharge",query: {url:location.href}})
			},
			
			// 选择支付方式弹框
			selectPayType(){
			    this.isShowModal = false;
			    this.payTypeModal = true;
			},
            
            //确定选择支付方式
            payType(name){
                this.payTypeModal = false;
                this.isShowModal = true;
                this.payStyle = name;
                name==1?this.payName ="微信支付":this.payName="钱包支付"
            },
			
			// 返回支付页面
			backPay(){
			    this.isShowModal = true;
			    this.payTypeModal = false;
			},
			
			// 关闭弹框
			onCloseModalClick(){
				this.isShowModal =false;   //关闭弹框
				this.noEnough = false;     //取消充值
				this.isDispatch =false;
				this.qrcodeUrl = false;
				clearTimeout(this.timer);
			},
			
			handleImgsClick(item,index) {
				this.initialIndex = index
				const params = {
					$props: {
						imgs: item,
						initialIndex: 'initialIndex', // 响应式数据的key名
						loop: false
					},
					$events: {
						change: (i) => {
							// 必须更新 initialIndex
							this.initialIndex = i
						}
					}
				}
				this.$createImagePreview({ ...params }).show()
			},
            
            backHeight(){
                setTimeout(() => {
                    const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
                    window.scrollTo(0, Math.max(scrollHeight - 1, 0));
                }, 100);
            }
        },
    }
</script>

<style lang='less' scoped>
    @import '~@/assets/styles/variable.less';
    @import '~@/assets/styles/handleMethods.less';
    @import '~@/assets/styles/reset.css';
    section{font-family:PingFangSC-Regular;font-weight:400;background:#F5F5F5}
    .service-left{color:rgba(51,51,51,1);text-align: justify;display: inline-block;vertical-align: top;.f-s(15)}
	.order-content{margin:10px 10px 0 10px;padding-bottom: 72px}
	.order-detail{margin-bottom: 10px;background: #fff}
	.order-wrap{font-size: 0;height: 1.38666667rem;padding-left:10px;padding-right:10px;line-height: 1.38666667rem;display: -webkit-box;display: -ms-flexbox;display: -webkit-flex;display: flex;border-bottom: 0.026667rem solid #EEEEEE;align-items: center;font-weight: 500}
	.un-boder{border: none;justify-content: space-between;}
	.pt-img{height: 20px;margin-right: 8px;display: inline-block;vertical-align:middle}
	.order-left{color:rgba(51,51,51,1);font-size:13px;}
    .link-wrap{font-size: 0;height: 1.38666667rem;margin: 0 10px;line-height: 1.38666667rem;border-bottom: 0.026667rem solid #EEEEEE;}
	.link{display: inline-block;vertical-align: middle;color:rgba(20,20,20,1);font-size: 0.4rem;}
	.show-link{width: 335px;padding: 10px;margin: 0 auto;color:rgba(74,74,74,1);font-size: 14px;box-sizing: content-box}
    .customer-info{padding: 10px 10px 2px 10px;display: -webkit-box;display: -ms-flexbox;display: flex;justify-content: space-between;align-items: center;}
    .info-style{color:rgba(74,74,74,1);font-size: 14px}
    .p-b{padding-bottom:8px}
    .f-s{color: #4a4a4a;font-size: 0.373333rem;}
    .un-connection{display: inline-block;color:rgba(65,132,244,1);font-size: 13;padding:5px 17px;background:rgba(239,247,255,1);border-radius:4px;margin: 11px 0 9px 10px}
    .describe{color:rgba(74,74,74,1);font-size: 14px;padding: 0 10px 8px 10px;}
    .img-list{display: -webkit-box;display: -ms-flexbox;display: flex;flex-wrap: wrap;padding:0 10px}
    .img-size{width: 78px;height:78px;margin-right: 7.5px;padding-bottom: 7.5px}
	.img-list .img-size:nth-child(4n){margin-right: 0}
	.agree-img{width: 22px;height: 22px;margin-right: 8px;display: inline-block;vertical-align:middle}
    .agree{background: url(../../assets/images/home/pic_right2_pitchon.png) center center no-repeat;background-size: cover}
    .un-agree{background: url(../../assets/images/home/pic_right2_pitchoff.png) center center no-repeat;background-size: cover}
    .agree-text{padding: 10px 22px 10px 15px}
    .agree-text p{font-size:14px;color:rgba(20,20,20,1);line-height:20px;margin-bottom: 10px}
	
	/* 设置处理人员 */
	.modal{width: 320px;/* height: 327px; */background: #fff;margin: 0 auto;padding-bottom: 20px;}
	.title{padding: 12px 21px;/* background: url(../../assets/images/home/pic_right2_pitchon.png) no-repeat 93% center;background-size: 12px; */font-size:18px;font-family:PingFangSC-Medium;font-weight:500;color:rgba(51,51,51,1);text-align: center;border-bottom: 1px solid #E9E9E9}
	.sale-wrap{padding:20px 25px 20px 22px;}
	.sale-wrap select{/* -webkit-appearance: none; */width: 100%;height: 40px;padding-left: 17px;margin-bottom: 14px;margin-top: 10px;background:rgba(245,245,245,1);border-radius:2px;border:1px solid rgba(151,151,151,1);}
	.name-title{font-size: 14px;font-family: PingFangSC-Regular;font-weight: 400;color: rgba(20,20,20,1);}
	.commission-wrap{width: 100%;height: 40px;margin-top: 10px;background: rgba(245,245,245,1);border-radius: 2px;border: 1px solid rgba(151,151,151,1)}
	.com-mb{margin-bottom: 14px}
	.commission-wrap input{width: 88%;height: 100%;padding-left: 17px;background: rgba(245,245,245,1);}
	.submit-sale{width:277.5px;height:40px;line-height: 40px;margin:0 auto;margin-top: 14px;background:rgba(65,132,244,1);border-radius:2px;font-size:18px;font-family:PingFangSC-Regular;font-weight:400;color:rgba(255,255,255,1);text-align: center}
</style>
